import { TypographyColor } from 'melp-design/components';
import { BenefitTemplateStatus } from './benefit-templates.types';

export const COLOR_BY_STATUS: Record<BenefitTemplateStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};
